/**
 * It returns an object with functions that can be used to track events and sessions
 * @param {Tracker} tracker - The tracker object that you get from the analytics library.
 */

import startTrackingSessionHandler from "./eventsToTrack/startTrackingSession"
import trackNewLoginHandler from "./eventsToTrack/trackNewLogin"
import trackLocalCouncilTabHandler from "./eventsToTrack/trackLocalCouncilTab"
import trackDirectiveCouncilTabHandler from "./eventsToTrack/trackDirectiveCouncilTab"
import trackTechnicalComitteeTabHandler from "./eventsToTrack/trackTechnicalComitteeTab"
import trackActiveProjectsTabHandler from "./eventsToTrack/trackActiveProjectsTab"
import trackClosedProjectsTabHandler from "./eventsToTrack/trackClosedProjectsTab"
import trackOpenSubmissionHandler from "./eventsToTrack/trackOpenSubmission"
import trackOpenProjectHandler from "./eventsToTrack/trackOpenProject"
import trackOpenBudgeAvailabilityHandler from "./eventsToTrack/trackBudgetAvailability"

export const TrackingService = tracker => {
  return {
    startTrackingSession:
      startTrackingSessionHandler(tracker).startTrackingSession,
    trackNewLogin:
      trackNewLoginHandler(tracker).trackNewLogin,
    trackLocalCouncilTab:
      trackLocalCouncilTabHandler(tracker).trackLocalCouncilTab,
    trackDirectiveCouncilTab:
      trackDirectiveCouncilTabHandler(tracker).trackDirectiveCouncilTab,
    trackTechnicalComitteeTab:
      trackTechnicalComitteeTabHandler(tracker).trackTechnicalComitteeTab,
    trackActiveProjectsTab:
      trackActiveProjectsTabHandler(tracker).trackActiveProjectsTab,
    trackClosedProjectsTab:
      trackClosedProjectsTabHandler(tracker).trackClosedProjectsTab,
    trackOpenSubmission:
      trackOpenSubmissionHandler(tracker).trackOpenSubmission,
    trackOpenProject:
      trackOpenProjectHandler(tracker).trackOpenProject,
    trackBudgetAvailability:
      trackOpenBudgeAvailabilityHandler(tracker).trackBudgeAvailability
  }
}
/**
 *@typedef {Function} Tracker
 *@returns { initTrackingSession: Function, trackEvent: Function }
 */

